export default {
  DEFAULT: 'DEFAULT_CONSENT',
  EDIT: 'EDIT_CONSENT',
};
